import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import AdminRouter from './admin/AdminRouter';
import PlataformaPage from './pages/PlataformaPage';
import { TermosPage, PrivacidadePage } from './pages/LegalPage';
import { CmsProvider } from './context/CmsContext';
import usePageTracker from './hooks/usePageTracker';
import reportWebVitals from './reportWebVitals';
const PageTracker = () => { usePageTracker(); return null; };

const Root = () => (
  <React.StrictMode>
    <BrowserRouter>
      <CmsProvider>
        <PageTracker />
        <Routes>
          <Route path="/admin/*" element={<AdminRouter />} />
          <Route path="/plataforma" element={<PlataformaPage />} />
          <Route path="/termos" element={<TermosPage />} />
          <Route path="/privacidade" element={<PrivacidadePage />} />
          <Route path="/*" element={<App />} />
        </Routes>
      </CmsProvider>
    </BrowserRouter>
  </React.StrictMode>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);


reportWebVitals();
